var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 15px;\n  padding-left: 15px;\n  width: 100%;\n\n  @media (min-width: 1200px){\n    max-width: 1140px;\n  }\n\n  @media (min-width: 768px) and (max-width: 1199px){\n    max-width: 768px;\n  }\n\n  @media (max-width: 767px){\n    max-width: 375px;\n  }\n'], ['\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 15px;\n  padding-left: 15px;\n  width: 100%;\n\n  @media (min-width: 1200px){\n    max-width: 1140px;\n  }\n\n  @media (min-width: 768px) and (max-width: 1199px){\n    max-width: 768px;\n  }\n\n  @media (max-width: 767px){\n    max-width: 375px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 20px 0;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 20px 0;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';

var ContainerDefinition = styled.div(_templateObject);

ContainerDefinition.displayName = 'Container';

export var Container = ContainerDefinition;

export var FlexRowDefinition = styled.div(_templateObject2);

FlexRowDefinition.displayName = 'FlexRow';

export var FlexRow = FlexRowDefinition;